<template>
    <el-row :gutter="2">
        <el-col :span="6">
            <div class="advImg">
                <el-image @click="goDetail(list.filter(o=>o.img_location === 11)[0].url)" v-if="list.filter(o=>o.img_location === 11).length > 0" style="width: 100%; height: 100px" :src="list.filter(o=>o.img_location === 11)[0].img" fit="cover"></el-image>
                <el-image v-else style="width: 100%; height: 100px" :src="nullBanner" fit="cover"></el-image>
                <div class="advImgGG">广告</div>
            </div>
            <div class="advImg">
                <el-image @click="goDetail(list.filter(o=>o.img_location === 12)[0].url)" v-if="list.filter(o=>o.img_location === 12).length > 0" style="width: 100%; height: 100px" :src="list.filter(o=>o.img_location === 12)[0].img" fit="cover"></el-image>
                <el-image v-else style="width: 100%; height: 100px" :src="nullBanner" fit="cover"></el-image>
                <div class="advImgGG">广告</div>
            </div>
            <div class="advImg">
                <el-image @click="goDetail(list.filter(o=>o.img_location === 13)[0].url)" v-if="list.filter(o=>o.img_location === 13).length > 0" style="width: 100%; height: 100px" :src="list.filter(o=>o.img_location === 13)[0].img" fit="cover"></el-image>
                <el-image v-else style="width: 100%; height: 100px" :src="nullBanner" fit="cover"></el-image>
                <div class="advImgGG">广告</div>
            </div>
        </el-col>
        <el-col :span="12">
            <div class="advImg">
                <el-carousel height="202px">
                    <el-carousel-item v-for="(item, index) in swiperList" :key="index">
                        <el-image style="width: 100%; height: 202px;" :src="item.ad_media" fit="cover" @click="goDetail(item.ad_param)"></el-image>
                    </el-carousel-item>
                </el-carousel>
                <div class="advImgGG">广告</div>
            </div>
            <div class="advImg">
                <el-image @click="goDetail(list.filter(o=>o.img_location === 14)[0].url)" v-if="list.filter(o=>o.img_location === 14).length > 0" style="width: 100%; height: 100px" :src="list.filter(o=>o.img_location === 14)[0].img" fit="cover"></el-image>
                <el-image v-else style="width: 100%; height: 100px" :src="nullBanner" fit="cover"></el-image>
                <div class="advImgGG">广告</div>
            </div>
        </el-col>
        <el-col :span="6">
            <div class="advImg">
                <el-image @click="goDetail(list.filter(o=>o.img_location === 15)[0].url)" v-if="list.filter(o=>o.img_location === 15).length > 0" style="width: 100%; height: 100px" :src="list.filter(o=>o.img_location === 15)[0].img" fit="cover"></el-image>
                <el-image v-else style="width: 100%; height: 100px" :src="nullBanner" fit="cover"></el-image>
                <div class="advImgGG">广告</div>
            </div>
            <div class="advImg">
                <el-image @click="goDetail(list.filter(o=>o.img_location === 16)[0].url)" v-if="list.filter(o=>o.img_location === 16).length > 0" style="width: 100%; height: 100px" :src="list.filter(o=>o.img_location === 16)[0].img" fit="cover"></el-image>
                <el-image v-else style="width: 100%; height: 100px" :src="nullBanner" fit="cover"></el-image>
                <div class="advImgGG">广告</div>
            </div>
            <div class="advImg">
                <el-image @click="goDetail(list.filter(o=>o.img_location === 17)[0].url)" v-if="list.filter(o=>o.img_location === 17).length > 0" style="width: 100%; height: 100px" :src="list.filter(o=>o.img_location === 17)[0].img" fit="cover"></el-image>
                <el-image v-else style="width: 100%; height: 100px" :src="nullBanner" fit="cover"></el-image>
                <div class="advImgGG">广告</div>
            </div>
        </el-col>
    </el-row>
</template>

<script>
import nullBanner from '../../assets/banner.png'
    export default {
        data() {
            return {
                nullBanner: nullBanner,
                list: [],
                swiperList: []
            }
        },
        mounted() {
            // 获取广告
            setTimeout(() => {
                this.getSwiper()
                this.getAdPcInfo()
            }, 500);

        },
        methods: {

            // 获取广告
            getAdPcInfo() {
                const areaStr = sessionStorage.getItem('area');
                if (!areaStr) {
                    console.warn('area 数据不存在，无法获取广告');
                    return;
                }
                const area = JSON.parse(areaStr);
                if (!area || !area.province_id || !area.city_id) {
                    console.warn('area 数据不完整，无法获取广告');
                    return;
                }
                let obj = {
                    province: area.province_id,
                    city: area.city_id
                }
                this.api.post('/6278aafd5b3e1', obj).then(r => {
                    this.list = r.data
                    this.list.forEach(o=>{
                        if(o.img_location === 11) {
                            console.log(o)
                        }
                    })
                })
            },

            // 广告跳转
            goDetail(url) {
                if(url) {
                    window.open(url)
                }
            },

            // 获取轮播图
            getSwiper() {
                const areaStr = sessionStorage.getItem('area');
                if (!areaStr) {
                    console.warn('area 数据不存在，无法获取轮播图');
                    return;
                }
                const area = JSON.parse(areaStr);
                if (!area || !area.province_id || !area.city_id) {
                    console.warn('area 数据不完整，无法获取轮播图');
                    return;
                }
                let obj = {
                    province: area.province_id,
                    city: area.city_id
                }
                this.api.get('/5cd934ed5fe4a', obj).then(r => {
                    this.swiperList = r.data.home.C_top_banner
                })
            }
        }
    }
</script>

<style lang="scss">
    .advImg {
        .el-carousel__indicators {
            display: none !important;
        }
    }
</style>

<style lang="scss" scoped>
    .advImg {
        font-size: 0;
        padding: 1px 0;
        position: relative;
        cursor: pointer;
        .advImgGG {
            position: absolute;
            right: 0;
            bottom: 0;
            font-size: 8px;
            background: rgba(256,256,256,.5);
            color: white;
            padding: 0 2px;
            z-index: 9;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/advertisement/index.vue